import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

// Api
import { getProfile } from 'api/profile'
import { logout as apiLogout } from 'api/auth'
import { getToken } from 'helpers/auth'

// Actions
import { clearFilters } from 'store/modules/dashboard'

// Async thunk
export const fetchUser = createAsyncThunk(
  'auth/fetchUser',
  async (_, { getState }) => {
    if (getToken()) {
      const { auth } = getState()

      if (auth.user && auth.user.email) {
        return auth.user
      }

      return await getProfile()
    }

    return Promise.reject()
  }
)
// Fetch user when edit profile success
export const getUserProfile = createAsyncThunk('auth/fetchUser', async () => {
  if (getToken()) {
    return await getProfile()
  }
  return Promise.reject()
})

export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { dispatch }) => {
    try {
      await apiLogout()

      dispatch(clearFilters())

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }
)

export const auth = createSlice({
  name: 'auth',
  initialState: {
    user: {},
  },
  reducers: {
    setUser: (state, { payload }) => {
      state.user = payload
    },
  },
  extraReducers: {
    [fetchUser.fulfilled]: (state, { payload }) => {
      state.user = payload
    },

    [logout.fulfilled]: (state) => {
      state.user = {}
    },
    [logout.rejected]: (state) => {
      state.user = {}
    },
  },
})

export default auth.reducer
